module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/009-uganda-8e96ea72dfa7d0de0cce73019a36dce8.svg";